export const CONFIG_MESSAGE = Object.freeze({
    SYSTEM: "system",
    ENTER: "Enter",
    EXPIRED_COLLABORATIVE: "expiredColaborative",
    RESET: "RESET",
    SINGLE: "SINGLE",
    SEQUENCE: "Sequence",
    LOGIN_PATH: "/login",
    PASSWORD: "password",
    ACCOUNT: "account",
    ME: "me",
    USER: "User",
    USERS: "users",
});

export const COMMAND_MESSAGE = Object.freeze({
    RESET: "RESET",
    FINISHED_COLLECTION: "FINISHED_COLLECTION",
});

export const MODAL_TYPE = Object.freeze({
    RESET: "RESET",
    TIMED_OUT: "timed_out",
    FINISHED_COLLECTION_OR_INDIVIDUAL: "finished_collection_individual",
    DIDACTIC_SEQUENCE: "DIDACTIC_SEQUENCE",
});

export const ROLE = Object.freeze({
    USER: "user",
    ADMIN: "admin",
    MODERATOR: "moderator",
});

export const LANGUAGE = Object.freeze({
    SPANISH: "es-ES",
    ENGLISH: "en-EN",
});

export const TEST_POST_PROBLEM = Object.freeze({
    NO_TEST_POST_PROBLEM: 0,
});

export const MESSAGE_TYPE = Object.freeze({
    CONVERSATIONAL: "CONVERSATION_MESSAGE",
    ACTION: "ACTION_MESSAGE"
})